import LayoutV2 from 'components/common/LayoutV2';
import MarketplaceIntro from 'components/community/gridV2/MarketplaceIntro';
import UsersForHireView from 'components/community/gridV2/UsersForHireView';

export default function LatestCommunityPage() {
  return (
    <LayoutV2
      title="Marketplace"
      showCommunitySearch
      showCommunityFilters
      selectedCommunityFilter="for-hire"
    >
      <MarketplaceIntro
        eyebrow="For hire"
        title="Creators for hire"
        description="Rive creators open to new work, with what they’ve published recently."
      />
      <UsersForHireView />
    </LayoutV2>
  );
}
